import React, { useState, useEffect } from 'react';

const FinancialNews = () => {
  const [news, setNews] = useState([]);
  const [loading, setLoading] = useState(true);
  const [expandedIndex, setExpandedIndex] = useState(null);

  const translateText = async (text) => {
    try {
      const response = await fetch(
        `https://translate.googleapis.com/translate_a/single?client=gtx&sl=en&tl=tr&dt=t&q=${encodeURIComponent(text)}`
      );
      const data = await response.json();
      return data[0][0][0];
    } catch (error) {
      console.error('Translation error:', error);
      return text;
    }
  };

  useEffect(() => {
    const fetchAndTranslateNews = async () => {
      try {
        const response = await fetch(
          `https://financialmodelingprep.com/api/v4/general_news?apikey=${process.env.REACT_APP_FMP_API_KEY}`
        );
        const data = await response.json();
        
        const translatedData = await Promise.all(
          data.map(async (item) => {
            try {
              const [translatedTitle, translatedText] = await Promise.all([
                translateText(item.title),
                translateText(item.text)
              ]);
              return {
                ...item,
                translatedTitle,
                translatedText
              };
            } catch (error) {
              console.error('Translation error:', error);
              return item;
            }
          })
        );
        
        setNews(translatedData);
      } catch (error) {
        console.error('Error:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchAndTranslateNews();
  }, []);

  const formatDate = (dateString) => {
    return new Intl.DateTimeFormat('tr-TR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    }).format(new Date(dateString));
  };

  if (loading) {
    return <div className="flex justify-center p-8"><p>Yükleniyor...</p></div>;
  }

  return (
    <div className="max-w-7xl mx-auto px-4 py-8">
      <h2 className="text-2xl font-bold mb-6">Finansal Haberler</h2>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {news.map((article, index) => (
          <div key={index} className="bg-white rounded-lg shadow-md overflow-hidden">
            <div className="aspect-video">
              <img
                src={article.image}
                alt={article.translatedTitle || article.title}
                className="w-full h-full object-cover"
              />
            </div>
            <div className="p-4">
              <h3 className="font-semibold text-lg mb-2">
                {article.translatedTitle || article.title}
              </h3>
              <p className="text-sm text-gray-500 mb-1">
                Yayınlanma: {formatDate(article.publishedDate)}
              </p>
              <p className="text-sm text-gray-500 mb-2">
                Kaynak: {article.site}
              </p>
              <p className="text-gray-400 mb-4">
                {expandedIndex === index ? 
                  (article.translatedText || article.text) :
                  ((article.translatedText || article.text).substring(0, 150) + "...")}
              </p>
              <button
                onClick={() => setExpandedIndex(expandedIndex === index ? null : index)}
                className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
              >
                {expandedIndex === index ? 'Gizle' : 'Devamını Oku'}
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FinancialNews;